import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { get, find } from "lodash";

import { showErrorToaster } from "../../globals/toaster";
import { getMetaDataApi } from "../../apis/portal";
import { MetaDataActions } from "../../redux/reducers/MetaDataReducer";

import PoonaWallaModal from "../PoonaWallaModal";
import PoonaWallaBasicLoader from "../PoonaWallaBasicLoader";

import "./TermsAndConditiondsModal.scss";

const TermsAndConditiondsModal = () => {
  const { tncData } = useSelector(
    (store) => ({
      tncData: find(store.metadata.data, (meta) => meta.meta_type === "tnc"),
    }),
    shallowEqual
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const qp = new URLSearchParams(location.search);

  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleUnmount = () => {
    // Remove Application Qparam & replace
    qp.delete("tnc");
    history.replace({
      search: qp.toString(),
    });
  };

  const getMetaData = async () => {
    try {
      setIsLoading(true);
      const res = await getMetaDataApi();
      dispatch(MetaDataActions.SET_META_DATA(res.data));
    } catch (error) {
      showErrorToaster(get(error, "data.detail", "Something went wrong."));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // SAFETY CONDITIONS, IF NO DATA WAS FOUND - TRY AGAIN
    if (!tncData) getMetaData();
  }, [tncData]);

  useEffect(() => {
    if (qp.get("tnc")) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [location.search]);

  return (
    <div className="TermsAndConditiondsModal">
      <PoonaWallaModal
        size="xl"
        handleHideModal={handleUnmount}
        isActive={isActive}
        title="Terms and Conditions"
      >
        {isLoading ? (
          <PoonaWallaBasicLoader isLoading={isLoading} />
        ) : (
          <>
            <b>TERMS GOVERNING USE OF API</b>
            <p>
              These terms of use as amended from time to time together with any
              other condition which may be implied by applicable law
              (collectively, “Terms”) shall apply to and regulate the operation
              of the Platform (defined below) which is offered by Fedbank
              Financial Services Limited (“Fedbank”) to the user
              (“User/Vendor”). By accepting these Terms, the User and the User’s
              Affiliates, wherever applicable, agree to use FFedbank Financial
              Services Limited (“Fedbank”) API Content (as defined below) and
              Application Programming Interface (“API”) found on the Platform in
              accordance with the Terms hereunder.
            </p>{" "}
            <br></br>
            <p>
              These Terms shall be in addition to and subject to any other terms
              as stipulated by the Fedbank Financial Services Limited
              (“Fedbank”) from time to time.
            </p>
            <br></br>
            <p>1. Definitions: </p>
            <br></br>
            <p>
              1.1. “Affiliate” means, with respect to either party, any
              partnership, joint venture, corporation, limited liability
              company, association or other legal entity, however organized
              (“Person”) that now or hereafter directly or indirectly through
              one or more intermediaries, controls, or is controlled by or is
              under common control with the party in question. For the purpose
              of this definition, “control” together with grammatical variations
              when used with respect to any Person, shall mean the power to
              direct the management and policies of such Person; directly or
              indirectly.
            </p>
            <br></br>
            <p>
              1.2. API means a set of subroutine definitions, protocols, and
              tools for building application software made available by the
              Fedbank Financial Services Limited (“Fedbank”) through the
              Platform to allow the User to access and/or use API
              Content/Services through its Application.
            </p>
            <br></br>
            <p>
              1.3. API Content means data or information made available by or
              delivered through a particular API.
            </p>
            <br></br>
            <p>
              1.4. Services means service(s) and/or function(s) accessible
              through or performed by a particular API
            </p>
            <br></br>
            <p>
              1.5. Application means a website and/or software application
              (regardless of how fully developed) owned by the User and visited
              or used (or developed with the intent to be visited or used
              eventually) by the User, common customers of the Fedbank Financial
              Services Limited (“Fedbank”) and the User or any natural person or
              company (End Users) to access and/or use API Content/Services.
            </p>
            <br></br>
            <p>
              1.6. Documentation means any online user guides, software
              development kit(s), and/or help and training materials for the
              APIs, as updated from time to time by the Fedbank Financial
              Services Limited (“Fedbank”), and accessed through the Platform.
            </p>
            <br></br>
            <p>
              1.7. “Defect” means a failure of the API(s) and/or the API
              Content/Services associated with any API(s) to perform in all
              material respects in accordance with its specifications.
            </p>
            <br></br>
            <p>
              1.8. “Harmful Code” means a self-propagating program such as a
              virus, worm, trojan horse, logic / time bomb, back / trap door and
              all similar forms of extraneous code or harmful components that
              damage other programs including any downloadable content which
              contains any harmful code. Provided however, a disabling device
              such as a product key or an expiry code will not be a Harmful
              Code.
            </p>
            <br></br>
            <p>
              1.9. “Intellectual Property(ies)” includes all patents,
              trademarks, permits, service marks, brands, trade names, trade
              secrets, proprietary information and knowledge, technology,
              computer programs, databases, copyrights, licenses, franchises,
              formulae, designs, geographical indications, and all other
              intellectual properties in relation to API, API Content/Services.
            </p>
            <br></br>
            <p>
              1.10. “Intellectual Property Rights” shall include all rights,
              benefits, title or interest in or to any Intellectual Property,
              anywhere in the world (whether registered or not and including all
              applications for the same).
            </p>
            <br></br>
            <p>
              1.11. ”Licensed Content” shall include the published APIs,
              services framework and related documentation (for instance,
              methodology & design, technical details of the system, data
              requirements, security controls, user manual, online help manual,
              maintenance requirements, interface document, sample code) or such
              content as may be provided by the Fedbank Financial Services
              Limited (“Fedbank”) at its sole discretion from time to time.
            </p>
            <br></br>
            <p>
              1.12. Platform means the website which hosts the API,
              Documentation and Licensed Content and is currently located at
              ……………….
            </p>
            <br></br>
            <p>2. Purpose </p>
            <br></br>
            <p>
              2.1. The User hereby seeks to request the Fedbank Financial
              Services Limited (“Fedbank”) to provide access to its API,
              Documentation and Licensed Content hosted on the Platform in order
              to configure its Application for exploring the possibility of its
              future digital integration with the Fedbank Financial Services
              Limited (“Fedbank”).
            </p>
            <br></br>
            <p>3. Grant of License </p>
            <br></br>
            <p>
              3.1. Subject to the Terms herein, the Fedbank Financial Services
              Limited (“Fedbank”) hereby grants the User a non-transferable,
              nonexclusive, non-assignable, revocable, non-sub-licensable,
              royalty-free right and license to (i) to access the Licensed
              Content on the Platform and (ii) to use the Licensed Content in
              order to configure its Application for future digital integration.
              Provided that, any future digital integration between the Parties
              shall be pursuant to a separate service agreement executed to this
              effect.
            </p>
            <br></br>
            <p>
              3.2. The Fedbank Financial Services Limited (“Fedbank”) hereby
              reserves the right to modify, change, or delete any of the
              Licensed Content and API, including but not limited to alter,
              modify, change or delete the Terms, from time to time, at its sole
              discretion.
            </p>
            <br></br>
            <p>
              3.4. The User agrees that any modification, change or deletion
              made by the Fedbank Financial Services Limited (“Fedbank”) to the
              Licensed Content, API or these Terms shall be applicable to the
              User, should you continue to avail this license and by choosing to
              so continue the User will have given its consent for any such
              modification, change or deletion.
            </p>
            <p>3.5 Permissions</p>
            <br></br>
            <p>
              By incorporating the API into its website or service, the User
              agrees that Fedbank Financial Services Limited (“Fedbank”) may
              collect and use information from the User as described in our
              Privacy Policy (“Annexure A” hereto). The User agrees that the
              User will have adequate privacy policies in place. The User also
              agrees that the Fedbank Financial Services Limited (“Fedbank”) may
              use automated methods to analyze the User’s website or service
              where the API and/or Licensed Content has been incorporated. The
              User agrees and undertakes to hold harmless and indemnify Fedbank
              Financial Services Limited (“Fedbank”) against any and all third
              party claims of whatsoever nature, costs, expenses, liability,
              damages, attorney fees for defending such claim that may arise out
              of use of the API.
            </p>
            <br></br>
            <p>4. API Restrictions </p>
            <br></br>
            <p>
              4.1. The User agrees that any use of an API and API
              Content/Services shall be subject to information security policies
              and procedures forming part of the Licensed Content and as per
              applicable law, including but not limited to OTP procedures, which
              may not be fully disclosed and may vary from time to time. The
              User agrees and undertakes that when accessing or using an API
              and/or API Content/Services, the User, the End Users and/or the
              User’s Application shall not:
            </p>
            <br></br>
            <p>
              4.1.1. modify, obscure, circumvent, or disable any element of an
              API and/or API Content Services, or their access control features;
            </p>
            <br></br>
            <p>
              4.1.2. disrupt, interfere with, or adversely impact the access or
              use of an API and/or API Content/Services by the Fedbank Financial
              Services Limited (“Fedbank”) or any other party whatsoever;
            </p>
            <br></br>
            <p>
              4.1.3. disclose, share, or transfer its username/password or OTP
              to any third party or allow such third party to access the User’s
              Platform account unless expressly authorized to do so under these
              Terms;
            </p>
            <br></br>
            <p>
              4.1.4. infringe, misuse, or claim ownership of the Fedbank
              Financial Services Limited (“Fedbank”) Intellectual Property;
            </p>
            <br></br>
            <p>
              4.1.5. transmit any Harmful Code or malware through its
              Application, access to or use of an API and/or API
              Content/Services;
            </p>
            <br></br>
            <p>4.1.6. allow any unauthorised access to the Platform;</p>
            <br></br>
            <p>
              4.1.7. use the API and/or API Content/Services in whole or in part
              for the purpose of serving as a factor in establishing an
              individual eligibility for credit, employment or insurance or for
              any other consumer initiated transaction;
            </p>
            <br></br>
            <p>
              4.1.8. use the API and/or API Content/Services in connection with
              an Application that offers, permits or promotes gambling within
              the Application;
            </p>
            <br></br>
            <p>
              4.1.9. use the API and/or API Content/Services in connection with
              an Application that is offensive, abusive, libelous, harassing,
              threatening, discriminatory, vulgar, pornographic, unethical,
              unlawful (or that promotes unlawful behavior), or that is
              otherwise inappropriate as determined by the Fedbank Financial
              Services Limited (“Fedbank”) in its sole discretion;
            </p>
            <br></br>
            <p>
              4.1.10. except as expressly authorized by the Fedbank Financial
              Services Limited (“Fedbank”), use any robot, spider, retrieval
              application, or other automated functionality to retrieve or index
              any portion of the Fedbank Financial Services Limited (“Fedbank”)
              data, products, or services for any unauthorized or authorized
              purpose;
            </p>
            <br></br>
            <p>
              4.1.11. use any API and/or API Content/Services in furtherance of
              or in connection with any live transaction (whether virtual or
              real) or any transaction with legal or other real consequences to
              the User, the End Users or any participant in the transaction,
              regardless of whether the data involved or was otherwise provided
              or furnished for use by the User, the End Users or the User’s
              Application;
            </p>
            <br></br>
            <p>
              4.1.12. access or use the API Content/ API Services in a manner
              not permitted by the Terms herein;
            </p>
            <br></br>
            <p>
              4.1.13. access or use the API Content/ API Services in violation
              of, or in a manner that would cause the Fedbank Financial Services
              Limited (“Fedbank”) and/or the Affiliates to be in violation of,
              any law, regulation or statutory or regulatory requirements
              applicable to the Fedbank Financial Services Limited (“Fedbank”)
              or the User.
            </p>
            <br></br>
            <p>
              4.2. The Fedbank Financial Services Limited (“Fedbank”) reserves
              the right to in its sole discretion, grant, deny, limit, or modify
              the User’s and/or the End Users access to and/or use of any API(s)
              and/or API Content/Services associated with any API(s).
            </p>
            <br></br>
            <p>5. Intellectual Property </p>
            <br></br>
            <p>
              5.1. It is hereby clarified that the Fedbank Financial Services
              Limited (“Fedbank”) retains all Intellectual Property Rights in
              all APIs, all API Content/Services, all Documentation and Licensed
              Content, the developer environments, and all other procedures,
              functionalities, software, documentation, trademarks or
              distinctive signs, images, photographs, patents, utility and
              industrial models, drawings, graphics, text files, audio and video
              files and all other content accessible on the Platform or in any
              of the APIs, and/or any API Content/Services.
            </p>
            <br></br>
            <p>5.2. The User hereby understands and acknowledges that:</p>
            <br></br>
            <p>
              5.2.1. The Fedbank Financial Services Limited (“Fedbank”) is the
              sole and absolute owner of the Fedbank Financial Services Limited
              (“Fedbank”) Intellectual Property (Fedbank Financial Services
              Limited (“Fedbank”) IP”);
            </p>
            <br></br>
            <p>
              5.2.2. The User shall not, nor shall it be deemed to, acquire at
              any time, any right, title or interest whatsoever, in, to or over
              Fedbank Financial Services Limited (“Fedbank”) IP or any
              combination thereof, in any language and/or trade name;
            </p>
            <br></br>
            <p>
              5.2.3. The User shall not claim or assert any right, title or
              interest in, to or over Fedbank Financial Services Limited
              (“Fedbank”) IP or take any action which shall or may impair the
              Fedbank Financial Services Limited (“Fedbank”) right, title or
              interest over Fedbank Financial Services Limited (“Fedbank”) IP;
            </p>{" "}
            <br></br>
            <p>
              5.2.4. The User shall not oppose or object to any right, title or
              interest that Fedbank Financial Services Limited (“Fedbank”) has
              or may have in Fedbank Financial Services Limited (“Fedbank”) IP;
            </p>
            <br></br>
            <p>
              5.2.5. The User shall not use the Intellectual Property in a
              manner that may be detrimental to the Fedbank Financial Services
              Limited (“Fedbank”);
            </p>
            <br></br>
            <p>
              5.2.6. The User shall not make any alterations or changes to
              Fedbank Financial Services Limited (“Fedbank”) IP, without the
              prior written approval of Fedbank Financial Services Limited
              (“Fedbank”);
            </p>
            <br></br>
            <p>
              5.2.6. The User shall not make any alterations or changes to
              Fedbank Financial Services Limited (“Fedbank”) IP, without the
              prior written approval of Fedbank Financial Services Limited
              (“Fedbank”);
            </p>
            <br></br>
            <p>
              5.2.7. The User shall not permit any person (other than persons
              authorised by the Fedbank Financial Services Limited (“Fedbank”))
              to use Fedbank Financial Services Limited (“Fedbank”) IP or any
              other Intellectual Property belonging to the Fedbank Financial
              Services Limited (“Fedbank”), including by the way of
              sub-licensing or otherwise, without the prior written consent of
              Fedbank Financial Services Limited (“Fedbank”);
            </p>
            <br></br>
            <p>
              5.2.8. The User is prohibited from using Fedfina Fincorp Limited
              IP for any business venture, marketing activity, promotional
              activity, or any other purpose, except as permitted herein above,
              without the prior written consent of the Fedbank Financial
              Services Limited (“Fedbank”);
            </p>
            <br></br>
            <p>
              5.2.9. The User shall share with the Fedbank Financial Services
              Limited (“Fedbank”), the samples/drafts of any materials/formats
              where Fedbank Financial Services Limited (“Fedbank”) IP is used
              and shall print/use/display such materials/formats only after
              obtaining prior written consent of Fedbank Financial Services
              Limited (“Fedbank”); and
            </p>
            <br></br>
            <p>
              5.2.10. The Fedbank Financial Services Limited (“Fedbank”)
              reserves the right to require the User, without assigning any
              reason, to discontinue temporarily or permanently the use of
              Fedbank Financial Services Limited (“Fedbank”) IP and the User
              shall promptly upon receipt of such notice, discontinue such use.
            </p>
            <br></br>
            <p>6. Representations and Warranties</p>
            <br></br>
            <p>The User hereby represents and warrants:</p>
            <br></br>
            <p>6.1. The User is not concealing or disguising its identity;</p>
            <br></br>
            <p>
              6.2. The User has a legitimate, lawful purpose for accessing and
              using the API and API Content/Services;
            </p>
            <br></br>
            <p>
              6.3. The User will perform no act that harms the Fedbank Financial
              Services Limited (“Fedbank”) or the Fedbank Financial Services
              Limited (“Fedbank”) rights and interests in the API and API
              Content/Services;
            </p>
            <br></br>
            <p>
              6.4. The User will promptly block, and notify the Fedbank
              Financial Services Limited (“Fedbank”) of, any known or suspected
              unauthorized or prohibited use of any API or API Content/Services
              or by a third party;
            </p>
            <br></br>
            <p>
              6.5. The User has obtained any and all necessary consent and
              approval to generally disclose to third parties and/or generally
              use any and all data that the User and the Application utilize
              under these Terms, including (but not limited to) data provided in
              the context of accessing and/or using API Content/Services; and
            </p>
            <br></br>
            <p>7. Indemnity </p>
            <br></br>
            <p>
              7.1. The User undertakes to indemnify, protect, defend, save and
              hold harmless the Fedbank Financial Services Limited (“Fedbank”)
              and its Affiliates, officers, directors, employees, agents, third
              parties, attorneys, successors, and assigns from and against:
            </p>
            <br></br>
            <p>
              7.1.1. any government, or other third party claim of loss,
              liability, penalty, assessment, civil or criminal fine, or damage
              to or asserted, whether through communication or formal filing,
              against the Fedbank Financial Services Limited (“Fedbank”) or its
              Affiliates (including reasonable attorney fees and expenses)
              related to, deriving from or associated with your Application;
            </p>
            <br></br>
            <p>
              7.1.2. any third party use of the Application (whether in whole or
              in part) to access or use of API(s) or API Content/Services (even
              if such activity is fraudulent), or any third party use of any API
              or API Content/Services (even if such activity is fraudulent);
            </p>
            <br></br>
            <p>
              7.1.3. the User’s violation of any representations, warranties,
              covenants and undertakings under these Terms;
            </p>
            <br></br>
            <p>
              7.1.4. any infringement of Fedbank Financial Services Limited
              (“Fedbank”) IP by the User, End Users or any third party
              associated with the User and/or the End User;
            </p>
            <br></br>
            <p>
              7.1.5. any breach of any conditions on which such Fedbank
              Financial Services Limited (“Fedbank”) IP has been provided to the
              User.
            </p>
            <br></br>
            <p>
              7.2. These indemnification provisions and the rights or
              obligations granted by or through it are in addition to any other
              rights or obligations that the Fedbank Financial Services Limited
              (“Fedbank”) may have under these Terms and applicable law and
              shall not be construed to provide an exclusive remedy.
            </p>
            <br></br>
            <p>
              7.3. Notwithstanding any other provision of the Terms herein, the
              indemnification provisions shall survive any termination or
              expiration of the Terms.
            </p>
            <br></br>
            <p>8. Limitation of Liability </p>
            <br></br>
            <p>
              8.1 In Addition to your liability for breach of these terms you
              shall be liable for breaches of confidentiality, any third party
              claim for intellectual property infringement, your use of the
              Licensed Content, in a manner inconsistent with the terms of these
              Terms of Use. Fedbank Financial Services Limited (“Fedbank”) will
              not be liable for any indirect, special, incidental,
              consequential, exemplary or punitive damages, including but not
              limited to damages for lost data, lost profits, lost revenue or
              costs of procurement of substitute goods or services, however
              caused and under any theory of liability, including but not
              limited to contract or tort (including product liability, strict
              liability and gross negligence), and whether or not Fedbank
              Financial Services Limited (“Fedbank”) was or should have been
              aware or advised of the possibility of such damage and
              notwithstanding the failure of essential purpose of any limited
              remedy stated herein. Further, in no event shall your liability be
              limited under this agreement.
            </p>
            <br></br>
            <p>
              8.2 Poonawalla Limited shall have no liability of any kind to you
              or any user of your applications with respect to such
              modifications or any adverse effects resulting from such
              modifications. Your continued access to or use of the API or API
              content/services shall constitute binding acceptance of the
              modification(s) at issue.
            </p>
            <br></br>
            <p>9. Confidentiality and Nondisclosure </p>
            <br></br>
            <p>
              9.1. The User acknowledges and agrees that the Fedbank Financial
              Services Limited (“Fedbank”) considers the username and password,
              information about API(s), API Content/ API Services disclosed to
              the User to be the Fedbank Financial Services Limited (“Fedbank”)
              confidential and proprietary information (Confidential
              Information) which may not be disclosed to any third party
              (including, but not limited to, your Affiliates) without the
              Fedbank Financial Services Limited (“Fedbank”) prior written
              consent.
            </p>
            <br></br>
            <p>
              9.2. The User agrees to use commercially reasonable means to
              maintain the confidentiality of Confidential Information in the
              User’s possession or contained in the Application, but in no
              circumstances means that are less stringent than those required by
              law or that the User uses to safeguard the User’s own confidential
              or proprietary information.
            </p>
            <br></br>
            <p>
              9.3. Upon termination of these Terms, you agree to destroy all
              copies of Confidential Information in the Users and/or the User’s
              contractor or third party agents possession, or control and, upon
              request, certify such destruction to the Fedbank Financial
              Services Limited (“Fedbank”).
            </p>
            <br></br>
            <p>
              9.4. The User agrees that the Fedbank Financial Services Limited
              (“Fedbank”) shall have no obligation whatsoever to keep
              confidential any and all data you provide to the Fedbank Financial
              Services Limited (“Fedbank”) under these Terms, including (but not
              limited to) data provided for use with API security services.
            </p>
            <br></br>
            <p>
              9.5. If the User applies for basic access, the Fedbank Financial
              Services Limited (“Fedbank”) will keep confidential the
              information that the User provides to the Fedbank Financial
              Services Limited (“Fedbank”) in connection with the User’s
              application to obtain basic access. However, the User acknowledges
              and agrees that the Fedbank Financial Services Limited (“Fedbank”)
              may be required to disclose the User’s confidential information if
              required by a judicial, administrative, governmental, or any other
              authority.
            </p>
            <br></br>
            <p>10. Data Protection </p>
            <br></br>
            <p>
              10.1. When accessing or using an API and/or API Content/Services
              the User agrees that the User, the End Users and/or the User’s
              Application shall use commercially reasonable efforts to ensure
              that cyber security measures are in place to protect the Fedbank
              Financial Services Limited (“Fedbank”) data and information which
              are accessed, processed, stored or transmitted irrespective of
              whether such place is housed at the Fedbank Financial Services
              Limited (“Fedbank”) premises or in the premises of a third party
              and comply with all applicable law in this respect.
            </p>
            <br></br>
            <p>
              10.2. The User shall immediately report to the Fedbank Financial
              Services Limited (“Fedbank”) any unauthorized access that has
              compromised the information or data of the Fedbank Financial
              Services Limited (“Fedbank”). In such report the User shall
              identify (i) the nature of the unauthorized use or disclosure,
              (ii) the information used or disclosed, (iii) who made the
              unauthorized use or received the unauthorized disclosure, (iv)
              what the User has done or shall do to mitigate the effects of the
              unauthorized use or disclosure, and (v) what corrective action has
              the User taken or shall take to prevent future similar
              unauthorized use or disclosure.
            </p>
            <br></br>
            <p>
              10.3. The User agrees and undertakes to hold the Fedbank Financial
              Services Limited (“Fedbank”) harmless and fully reimburse the
              Fedbank Financial Services Limited (“Fedbank”) without any demur,
              in respect of all costs, expenses, damages and liabilities arising
              out of or in any manner connected with such unauthorized access.
            </p>
            <br></br>
            <p>11. Right to Terminate </p>
            <br></br>
            <p>
              11.1. The Fedbank Financial Services Limited (“Fedbank”) reserves
              the right to terminate these Terms at its sole discretion and
              without assigning any reason whatsoever to the User. These terms
              will also be terminated by the Fedbank Financial Services Limited
              (“Fedbank”) on any information or belief that there has been an
              unauthorized access by a third party using the username and
              password of the User, any breach of the User’s confidentiality
              obligations, any breach of applicable rules and regulations, and
              any other breach of these Terms by the User. The Fedbank Financial
              Services Limited (“Fedbank”) may also elect to temporarily suspend
              the User’s access to any API(s) or API Content/Services till such
              breach is cured if it is remediable in nature.
            </p>
            <br></br>
            <p>
              11.2. In the event of a termination by either party, you agree to
              cease using all APIs accessed pursuant to this arrangement,
              promptly (but under any circumstances in no more than two (2)
              business days) remove the API and API Content/Services from your
              Application, and delete any API Content/Services that are
              possessed or controlled by the User.
            </p>
            <br></br>
            <p>12. Force Majeure</p>
            <br></br>
            <p>
              12.1. Any delay in or failure of performance by the Fedbank
              Financial Services Limited (“Fedbank”) under these Terms will not
              be considered a breach of these Terms and the Fedbank Financial
              Services Limited (“Fedbank”) will not be held liable for any such
              delay or failure in performance to the extent that such delay or
              failure is caused by any occurrence beyond its reasonable control,
              including, but not limited to, acts of God, power outages,
              failures of the Internet, war, terrorism, civil or political
              disturbance, lock-outs, floods, fire, or any other unforeseeable
              event.
            </p>
            <br></br>
            <p>13. Arbitration and Governing Law</p>
            <br></br>
            <p>13.1 Arbitration</p>
            <br></br>
            <p>
              (a) In the event of any claim, difference, dispute or controversy
              between the parties hereto arising under this Agreement or / out
              of or in connection with this Agreement, such claim, difference,
              dispute or controversy shall be referred to and settled by
              arbitration.  The arbitration shall be conducted in Mumbai in
              accordance with the Rules of Arbitration of the /Indian Merchants
              Chamber (IMC)] ( (the “Rules”), which Rules, as modified from time
              to time, are deemed to be incorporated by reference into this
              Section (provided that, in the event of any conflict between the
              Rules and the provisions of this Part, the latter shall prevail).
            </p>
            <br></br>
            <p>
              (b) The Tribunal shall consist of [one/ three] arbitrators.  Each
              party shall individually nominate one arbitrator.  The third
              arbitrator (who shall be Chairman of the Tribunal) shall be
              appointed by the IMC.
            </p>
            <br></br>
            <p>(c) The language of the arbitration shall be English.</p>
            <br></br>
            <p>
              (d) The Tribunal shall state the reason for its decisions in
              writing and shall not make such decisions on the basis of the
              principle of ex aequo et bono or as amiable compositeur.
            </p>
            <br></br>
            <p>13.2 Jurisdiction</p>
            <br></br>
            <p>
              (a) Subject to the provisions of sub-clause (b) above, with
              respect to any suit, action or proceedings relating to this
              Agreement including in relation to any arbitration award
              (“Proceedings”) the courts and tribunals of competent jurisdiction
              at Mumbai shall have exclusive jurisdiction.
            </p>
            <br></br>
            <p>
              (b)Each party irrevocably waives any objection which it may have
              at any time to the laying of venue of any Proceedings brought in
              any such tribunal or court, waives any claim that such Proceedings
              have been brought in an inconvenient forum and further waives the
              right to object, with respect to such Proceedings, that such
              tribunal or court does not have any jurisdiction over such party.
            </p>
            <br></br>
            <p>
              13.1. The Parties agree that these Terms and all rights and
              obligations of the Parties hereunder shall be governed, construed
              and interpreted exclusively under the laws of India, and shall be
              subject to the exclusive jurisdiction of the courts of Mumbai.
            </p>
            <br></br>
            <p>14. Relationship Between Parties: </p>
            <br></br>
            <p>
              14.1. These Terms of Use are on a “principal to principal” basis
              and the Parties are independent of each other and nothing
              contained herein is intended to or shall be deemed to create any
              partnership, joint venture, employment or relationship of
              principal and agent between Fedbank Financial Services Limited
              (“Fedbank”) and you and if applicable your representatives and
              employees or between you and the representatives and employees of
              Fedfina Fincorp Limited or to provide either of the Parties with
              any right, power or authority, whether express or implied to
              create any such duty or obligation on behalf of the other party.
            </p>
            <br></br>
            <p>15. Disclaimer</p>
            <br></br>
            <p>
              15.1. The Fedbank Financial Services Limited (“Fedbank”) provides
              API(s) and API Content/Services on an as is and as available
              basis. The Fedbank Financial Services Limited (“Fedbank”) hereby
              disclaims any and all warranties, express, implied or statutory
              regarding any API(s) or API Content/Services, including warranties
              of accuracy, merchantability, fitness for a particular purpose, or
              non-infringement.
            </p>
            <br></br>
            <p>
              15.2. The User acknowledges and confirms that the access to API,
              Licensed Content, Documentation, and other properties by the
              Fedbank Financial Services Limited (“Fedbank”) to the User shall
              not be construed in any manner that the Fedbank Financial Services
              Limited (“Fedbank”) is obligated to undertake user acceptance test
              (UAT) of the Application and/or use the Application for any
              purpose. The Fedbank Financial Services Limited (“Fedbank”) shall
              at its own absolute discretion undertake UAT of the Application
              and/or use the Application for any purpose.
            </p>
            <br></br>
            <p>
              15.3. The User is solely and entirely responsible for the
              Application, including but not limited to the Application
              development, operation, maintenance, and compliance with all
              applicable local, state, central and international laws and
              regulations, and all materials that appear on or within the
              Application. The Fedbank Financial Services Limited (“Fedbank”)
              hereby disclaims all liability with respect to the same.
            </p>
            <br></br>
            <p>
              The User agrees that by clicking on “accept” on the Platform the
              User shall indicate that it has read, understood and accepted
              these Terms.{" "}
            </p>
          </>
        )}
      </PoonaWallaModal>
    </div>
  );
};

export default TermsAndConditiondsModal;
